const productRecommendationsSection = document.querySelector(
  ".product-recommendations"
);
const url = productRecommendationsSection.dataset.url;

window.addEventListener("load", () => {
  setRecommendedProductsHTML()
    .then(() => {
      const upsellCheckboxes = document.querySelectorAll(
        ".complementary-products__block input"
      );
      initializeAtcPrice(upsellCheckboxes);
      setCheckboxChange(upsellCheckboxes);
      initalizeAtcClick();
    })
    .catch((err) => {
      console.log(err);
    });
});

const initializeAtcPrice = (upsellCheckboxes) => {
  if (upsellCheckboxes) {
    let checkedInputs = document.querySelectorAll(
      ".complementary-products__block input:checked"
    );
    const InitPrice = getTotalPrice(checkedInputs);
    displayPrice(InitPrice, checkedInputs.length);
  }
};

const setCheckboxChange = (upsellCheckboxes) => {
  upsellCheckboxes.forEach((input) => {
    input.addEventListener("change", () => {
      let checkedInputs = document.querySelectorAll(
        ".complementary-products__block input:checked"
      );
      let totalPrice = getTotalPrice(checkedInputs);
      displayPrice(totalPrice, checkedInputs.length);
    });
  });
};

const getTotalPrice = (checkedInputs) => {
  let totalPrice = 0;
  checkedInputs.forEach((input) => {
    totalPrice += Number(input.getAttribute("aria-price"));
  });
  return totalPrice.toFixed(2);
};

let upsellAtcButton;
const displayPrice = (price, quantity) => {
  upsellAtcButton = document.querySelector(".recommended-product__atc");
  if (upsellAtcButton) {
    switch (quantity) {
      case 0:
        upsellAtcButton.disabled = true;
        upsellAtcButton.innerHTML = "Select a product...";
        break;
      case 1:
        upsellAtcButton.disabled = false;
        upsellAtcButton.innerHTML = `Add to Cart - $${price}`;
        break;
      case 2:
        upsellAtcButton.innerHTML = `Add 2 to Cart - $${price}`;
        break;
      default:
        upsellAtcButton.innerHTML = `Add all 3 to Cart - $${price}`;
    }
  }
};

const setRecommendedProductsHTML = async () => {
  await fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;

      const recommendations = html.querySelector(".product-recommendations");
      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
    })
    .catch((e) => {
      console.error(e);
    });
};

const initalizeAtcClick = () => {
  if (upsellAtcButton) {
    upsellAtcButton.addEventListener("click", async (e) => {
      e.target.innerHTML = "adding...";
      e.target.setAttribute("disabled", "");

      let checkedInputs = document.querySelectorAll(
        ".complementary-products__block input:checked"
      );

      // Collect all checked upsell items
      let items = [];
      checkedInputs.forEach((input) => {
        items.push({
          quantity: 1,
          id: input.value,
          properties: { _upsell_tagging: "FBT-true" },
        });
      });

      if (items.length === 0) {
        e.target.innerHTML = "Added";
        e.target.removeAttribute("disabled");
        return;
      }

      try {
        // 1. Quietly add all items except the last via fetch (no OCU trigger)
        const quietItems = items.slice(0, -1);
        const mainItem = items[items.length - 1];

        if (quietItems.length > 0) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: quietItems }),
          });
        }

        // 2. Trigger the last item via fake product-form so OCU opens the drawer
        const wrapper = document.createElement('product-form');
        wrapper.innerHTML = `
          <div class="product-form__error-message-wrapper" role="alert" hidden>
            <span class="product-form__error-message"></span>
          </div>
          <form method="post" action="/cart/add" class="form"
                data-type="add-to-cart-form">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="id" value="${mainItem.id}">
            <input type="hidden" name="quantity" value="1">
            <div class="product-form__buttons">
              <button type="submit" name="add" class="product-form__submit button"
                      aria-haspopup="dialog">
                <span>Add</span>
                <div class="loading-overlay__spinner hidden">
                  <svg viewBox="0 0 66 66">
                    <circle class="path" fill="none" stroke-width="6"
                            cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </button>
            </div>
          </form>
        `;
        wrapper.style.display = 'none';
        document.body.appendChild(wrapper);

        setTimeout(() => {
          wrapper.querySelector('button[name="add"]').click();
          e.target.innerHTML = "Added";
          e.target.removeAttribute("disabled");
          setTimeout(() => wrapper.remove(), 5000);
        }, 1000);

      } catch (err) {
        console.error(err);
        window.location.reload();
      }
    });
  }
};
